import "./bootstrap-masonry.js";
import "./partials/desktop-search.js";
import $ from "jquery";
import "jquery-ui/ui/widgets/autocomplete";
import init from "./partials/desktop-search.js";

// KEEP THIS COMMENTED OUT UNTIL WE MERGE TO STAGING
// BECAUSE WE DON'T KNOW IF THIS WILL BREAK ANYTHING
// import "./select2.min.js";
// window.$ = $;
// window.jQuery = $;

// Initialize flatpickr
document.addEventListener("DOMContentLoaded", async () => {
  const modulesToLoad = document.querySelectorAll("[data-module]");

  function bindAutocomplete(selector, onSelect) {
    $(selector).each(function () {
      const searchInput = $(this);
      searchInput.autocomplete({
        minLength: 2,
        source: function (request, response) {
          const requestPayload = { term: request.term };
          const sourceForm = searchInput.closest("form");
          if (sourceForm.length) {
            const startDateValue = sourceForm
              .find('input[name="startDate"]')
              .first()
              .val();
            const endDateValue = sourceForm
              .find('input[name="endDate"]')
              .first()
              .val();
            if (startDateValue) {
              requestPayload.startDate = startDateValue;
            }
            if (endDateValue) {
              requestPayload.endDate = endDateValue;
            }
          }

          jQuery.ajax({
            headers: {
              "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            type: "POST",
            url: "/search/autocomplete",
            data: requestPayload,
            success: function (data) {
              response(data.shows.slice(0, 15));
            },
            error: function () {
              swal({
                title: "<span style='color:red;'>Error!</span>",
                text: "There was an error trying to the autocomplete shows",
                html: true,
                type: "error",
              });
            },
          });
        },
        select: function (event, ui) {
          searchInput.val(ui.item.name);
          if (typeof onSelect === "function") {
            onSelect(ui.item, searchInput);
          }
          return false;
        },
      });

      const autocompleteInstance = searchInput.autocomplete("instance");
      if (autocompleteInstance) {
        autocompleteInstance._renderItem = function (ul, item) {
          const price =
            !item.starting_at || item.starting_at == ""
              ? item.price
              : item.starting_at;
          const rawHTML = `
              <img src="${item.logo_url}" />
              <div>
                  ${item.name}
                  <span>${item.category} | Price: <b>$${price}</b></span>
              </div>
          `;
          return $("<li>")
            .append("<div>" + rawHTML + "</div>")
            .appendTo(ul);
        };
      }
    });
  }

  // Legacy header quick-search (non-form search input)
  bindAutocomplete("#search-header-input", (item) => {
    window.location.href = `/event/${item.slug}`;
  });

  // Main desktop search bar in header: selecting a show should go to that event page.
  bindAutocomplete("#desktop-name-search-input", (item, input) => {
    if (item && item.slug) {
      window.location.href = `/event/${item.slug}`;
      return;
    }

    const form = input.closest("form");
    if (form.length) {
      form.trigger("submit");
    }
  });

  const loggedUserButton = document.getElementById("logged_user_button");
  if (
    loggedUserButton?.dataset.forcePasswordReset === "1" &&
    typeof jQuery !== "undefined" &&
    document.getElementById("modal_account_settings")
  ) {
    if (typeof window.openAccountSettingsTab === "function") {
      window.openAccountSettingsTab("password");
    } else {
      jQuery("#modal_account_settings").modal("show");
    }
  }

  for (const el of modulesToLoad) {
    const moduleName = el.getAttribute("data-module");
    try {
      const module = await import(`./partials/${moduleName}.js`);
      module.default(); // call exported function
    } catch (error) {
      console.error(`Failed to load module: ${moduleName}`, error);
    }
  }
  init();
});
